// extracted by mini-css-extract-plugin
module.exports = {"GameTag":"GameTag","GameTag__Label":"GameTag__Label","GameTag__Thumbnail":"GameTag__Thumbnail"};